import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AbstractComponent } from '../../../../shared/components/abstract-component/abstract.component';
import { GbPrintService } from '../../../../core/services/app-print.service';
import { sanatizedSaveAs } from '../../../../shared/functions/file.functions';
import { CapSpinnerSmallComponent } from '../../../../shared/components/cap-spinner-small/cap-spinner-small.component';

@Component({
  selector: 'cap-print-grundbuchmeldung',
  templateUrl: './print-grundbuchmeldung.component.html',
  styleUrls: ['./print-grundbuchmeldung.component.scss'],
  imports: [CapSpinnerSmallComponent]
})
export class PrintGrundbuchmeldungComponent extends AbstractComponent implements OnInit {
  constructor(
    private printService: GbPrintService,
    private location: Location,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSub(
      this.route.queryParamMap.subscribe((q) => {
        if (this.route.snapshot.routeConfig.path.indexOf('generatepdf') > 0) {
          this.addSub(
            this.printService
              .getGrundbuchmeldungPDFByFachId(
                q.get('egbtbid'),
                +q.get('amtnr'),
                +q.get('jahr'),
                +q.get('nummer'),
                +q.get('index'),
                q.get('sprache')
              )
              .subscribe(
                (data) => {
                  this.saveFile(q, data, 'pdf');
                  this.router.navigate(['/home']);
                },
                (err) => this.handleError(err)
              )
          );
        } else if (this.route.snapshot.routeConfig.path.indexOf('generatertf') > 0) {
          this.addSub(
            this.printService
              .getGrundbuchmeldungRTFByFachId(
                q.get('egbtbid'),
                +q.get('amtnr'),
                +q.get('jahr'),
                +q.get('nummer'),
                +q.get('index'),
                q.get('sprache')
              )
              .subscribe(
                (data) => {
                  this.saveFile(q, data, 'rtf');
                  this.router.navigate(['/home']);
                },
                (err) => this.handleError(err)
              )
          );
        }
      })
    );
  }

  private handleError(err): void {
    if (err.status === 404) {
      this.router.navigate(['/home/notfound']);
    }
    if (err.status === 403) {
      this.router.navigate(['/security/forbidden']);
    }
  }

  private saveFile(queryParams: ParamMap, data, type: 'pdf' | 'rtf') {
    let title = this.translate.instant('grundbuchmeldung_');
    if (queryParams.get('egbtbid')) {
      title += queryParams.get('egbtbid');
    } else {
      title += queryParams.get('amtnr') ? queryParams.get('amtnr') : '';
      title += queryParams.get('jahr') ? '_' + queryParams.get('jahr') : '';
      title += queryParams.get('nummer') ? '-' + queryParams.get('nummer') : '';
      title += queryParams.get('index') ? '-' + queryParams.get('index') : '';
    }
    title += '.' + type;
    const file: Blob & { name?: string } = new Blob([data], { type: 'application/' + type });
    file.name = title;
    sanatizedSaveAs(file);
  }
}
